import { ApiUrls } from '@/service/constants/urls';
import { instance } from '../Axios';
import {
    TAvailabilityDayFullParams,
    TAvailabilityDayFullBody,
    TAvailabilityDayFullResponse,
} from '@/domain/FullCalendar.domain';
import { replaceLightframe } from '@/service/utils/replaceLightframe';

export const getAvailabilityDayFull = async (
    params: TAvailabilityDayFullParams,
    body: TAvailabilityDayFullBody
): Promise<TAvailabilityDayFullResponse> =>
    instance
        .post(
            ApiUrls.availability.day.full,
            { ...body },
            { params: { ...params, partnerId: replaceLightframe(params.partnerId) } }
        )
        .then(({ data }) => {
            /* if(body.schedule_id && data?.schedule){
                const { schedule, ...restData } = data;
                restData.schedules = {
                    [body.schedule_id]: schedule,
                };

                return restData;
            }; */

            return data;
        });
